import React, { useState, useEffect } from "react";
import { Space } from "antd";
import { DeleteFilled, PlusOutlined } from "@ant-design/icons";

import { Select, BaseButton } from "@/components";
const Selector = ({
  content = () => {},
  list = [],
  onClickDelete = () => {},
  onClickAdd = () => {},
  deleteButtonText = "删除本组",
  addFrameText = "添加帧数",
  selectTitles = [],
}) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const realIndex = list.length === 0 ? 0 : selectedIndex % list.length;
  useEffect(() => {
    setSelectedIndex(realIndex);
  }, [list]);
  return (
    <Space direction="vertical" size={10} align="start">
      <Select
        chooseList={list.map((_, i) => selectTitles[i] || `第${i + 1}组`)}
        onClick={(idx) => {
          setSelectedIndex(idx);
        }}
        currentIndex={realIndex}
      ></Select>
      {content(list[realIndex], realIndex)}
      <Space>
        <BaseButton
          style={{
            width: 155,
          }}
          type="normal"
          icon={<DeleteFilled />}
          content={deleteButtonText}
          onClick={() => {
            onClickDelete(selectedIndex);
          }}
        />
        <BaseButton
          style={{
            width: 155,
          }}
          type="normal"
          icon={<PlusOutlined />}
          content={addFrameText}
          onClick={() => {
            onClickAdd();
          }}
        />
      </Space>
    </Space>
  );
};

export default Selector;
